<template>
  <div v-if="user" class="avatar-new-container" :class="'avatar--' + size">
    <div
      class="avatar-new"
      :class="{'clickable': canStartConversation(user)}"
      @click="startConversation(user, 'announcementHeader.startConversation')"
    >
      <div
        :style="backgroundImageStyle"
        :class="(!!backgroundImageStyle) ? 'has-image' : 'has-no-image'"
        v-tooltip.right="canStartConversation(user) ? 'Start conversation with ' + user.name : (user.id === userId ? 'You': '')"
        class="avatar-image"
      >
      </div>
    </div>
    <div class="avatar-new-user" style="align-self: center; margin-left: 0.5rem;" v-if="showDetails">
      <h4><strong>{{ user.name }}</strong></h4>
      <span class="avatar-new-user-department" v-if="user.department">{{ user.department }}</span>
    </div>
  </div>
</template>
<script lang="ts">
  import { defineComponent } from 'vue'
  import { ConversationsMixin } from '@/util/ConversationsMixin'
  import UserMixin from '@/util/UserMixin'
  import { trackHeapEvent } from '@/util/analytics'
  import { Conversations } from '@/api/conversations'
  import { ACTION_TYPES as CONVERSATION_ACTION_TYPES } from '@/store/modules/conversations'
  import { MUTATION_TYPES as UI_MUTATION_TYPES } from '@/store/modules/ui'

  export default defineComponent({
    name: "AvatarNew",
    mixins: [ConversationsMixin, UserMixin],
    props: {
      user: {
        type: Object,
        required: true,
      },
      showDetails: {
        type: Boolean,
        required: false,
        default: false,
      },
      size: {
        type: String,
        validator: val => ['small'].includes(val)
      }
    },
    computed: {
      backgroundImageStyle() {
        return `background-image: url(${this.user.photoUrl || this.user.photo_url})`
      }
    },
    methods: {
      canStartConversation(user) {
        if (!this.isLoggedIn) {
          return false
        }

        if (!this.hasAccessToConversations) {
          return false
        }

        if (user.is_deleted) {
          return false
        }

        if (user.id === this.userId) {
          return false
        }

        return this.$store.getters.canActorsBeContacted || this.isOwner
      },
      startConversation(user, trackHeap = 'announcementDetail.clickConversation') {
        if (!this.canStartConversation(user) || this.userId === user.id) {
          return
        }

        trackHeapEvent(trackHeap)

        Conversations.post({ recipient_id: user.id }).then((conversation) => {
          this.$store.dispatch(CONVERSATION_ACTION_TYPES.FETCH_CONVERSATIONS_LIST)
          this.$router.push('/profile/conversations/' + conversation.id).then(() => {
            this.$store.commit(UI_MUTATION_TYPES.SHOW_SIDE_PANEL, {
              component: 'user-information-side-panel',
              metaData: {
                userId: user.id,
                allowDelete: false,
              },
            })
          })
        })
      },
    }
  })
</script>

<style scoped lang="scss">
  .avatar--small {
    .avatar-new {
      width: 25px;
      height: 25px;

    }

    .avatar-new-user {
      h4 {
        font-size: 12px !important;
      }

      span {
        font-size: 10px !important;
      }
    }
  }


  .avatar-new {
    cursor: pointer;
    position: relative;
    width: 35px;
    height: 35px;

    .avatar-image {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }

  .avatar-new-container {
    display: flex;
    flex-direction: row;
  }

  .avatar-new-user {
    display: flex;
    flex-direction: column;

    .avatar-new-user-department {
      color: var(--primary-community-dark);
      font-size: 11px;
    }
  }
</style>
